export default "__VITE_ASSET__DRoMUIIa__"